export default "__VITE_ASSET__CuH1l6G5__"